// 硬件覆盖

import { RootObject, Datum2 } from '../../type';
import './style.less';


const HardwareCoverage = (props: RootObject["hardwareCoverage"]) => {
  return (
    <div className="hardware_coverage">
      <div className="hardware_coverage_title">
        {props.title ?? ""}
      </div>
      <div className="hardware_coverage_table">
        <div className="table_header">
          <div className="table_tr_th">
            {props.armCpu32bitTitle ?? ""}
          </div>
          <div className="table_tr_th">
            {props.armCpu64bitTitle ?? ""}
          </div>
          <div className="table_tr_th">
            {props.JetsonTitle ?? ""}
          </div>
          <div className="table_tr_th">
            {props.x86_cpuTitle ?? ""}
          </div>
          <div className="table_tr_th">
            {props.nvidia_GPUTitle ?? ""}
          </div>
        </div>
        {
          props.data.map((value: Datum2, index: number) => {
            return (
              <div className="table_body" key={index}>
                <div className="table_tr_td">
                  {
                    value.armCpu32bit.columnOne ?? ""
                  }
                </div>
                <div className="table_tr_td">
                  {
                    value.armCpu32bit.columnTwo ?? ""
                  }
                </div>
                <div className="table_tr_td">
                  {
                    value.armCpu64bit.columnOne ?? ""
                  }
                </div>
                <div className="table_tr_td">
                  {
                    value.armCpu64bit.columnTwo ?? ""
                  }
                </div>
                <div className="table_tr_td">
                  {
                    value.Jetson.columnOne ?? ""
                  }
                </div>
                <div className="table_tr_td">
                  {
                    value.x86_cpu.columnOne ?? ""
                  }
                </div>
                <div className="table_tr_td"  {...{ dangerouslySetInnerHTML: { __html: value.nvidia_GPU.columnOne } }}></div>
              </div>
            )
          })
        }


      </div>
    </div>
  )
}

export default HardwareCoverage;